<template>
  <div v-if="visible" class="confirmation-overlay" @click.self="cancel">
    <div class="confirmation-dialog">
      <!-- colored card behind -->
      <div class="confirmation-dialog-bg"></div>
      <!-- main white card -->
      <div class="confirmation-dialog-inner">
        <button class="confirmation-close" @click="cancel">&times;</button>

        <div class="confirmation-icon">
          <v-icon>mdi-alert-circle</v-icon>
        </div>

        <h2 class="confirmation-title">{{ title }}</h2>
        <p class="confirmation-message">{{ message }}</p>
        
        <div class="confirmation-buttons">
          <button class="confirmation-button cancel" @click="cancel">
            {{ cancelText }}
          </button>
          <button class="confirmation-button confirm" @click="confirm">
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: "Confirm Action"
    },
    message: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: "Confirm"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
      this.$emit("update:visible", false);
    },
    cancel() {
      this.$emit("cancel");
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
.confirmation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.confirmation-dialog {
  position: relative;
  width: 500px;
  max-width: 90vw;
  min-height: 200px;
}

.confirmation-dialog-bg {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 96%;
  height: 100%;
  border-radius: 16px;
  background-color: #002060;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.confirmation-dialog-inner {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.confirmation-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
  color: #666;
}

.confirmation-close:hover {
  color: #333;
}

.confirmation-icon {
  position: relative;
  margin: 0 auto 24px auto;
  margin-top: -16%;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #002060;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeInCircle 0.3s ease-out forwards;
}

.confirmation-icon .v-icon {
  font-size: 40px;
  color: #ffffff;
}

.confirmation-icon::before {
  content: '';
  position: absolute;
  width: 100px;
  height: 100px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: #002060;
  opacity: 0.2;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes fadeInCircle {
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
  }
}

.confirmation-title {
  font-size: 2em;
  margin: 0 0 12px 0;
  color: #002060;
}

.confirmation-message {
  font-size: 1.2em;
  margin: 0 0 32px 0;
  color: #666;
}

.confirmation-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.confirmation-button {
  border: none;
  border-radius: 8px;
  font-size: 1.1em;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirmation-button.cancel {
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}

.confirmation-button.cancel:hover {
  background-color: #e8e8e8;
  color: #333;
}

.confirmation-button.confirm {
  background-color: #002060;
  color: #ffffff;
}

.confirmation-button.confirm:hover {
  background-color: #002060;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 32, 96, 0.3);
}
</style> 